import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CountryListObject, countryRegionObject } from '../models/model';
import { TileInfo } from '../../modules/customer-portal-home/customer-portal-home-config';
import { ProductHtmlUrl, ProductImage, ResourcesLinks } from '../models/customer-portal.model';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  httpClient = inject(HttpClient);
  countryListURL = '/assets/country_list.json';
  guidedBytopicsURL = '/assets/guidedByTopics.json';
  countryRegionURL = '/assets/country-region.json';
  resourcesLinks = '/assets/resources-links.json';
  productImagesURL = '/assets/product-images.json';
  productHtmlURL = '/assets/product-html-urls.json';

  
  getCountryList(): Observable<CountryListObject[]> {
    return this.httpClient.get<CountryListObject[]>(this.countryListURL);
  }

  /**
   * get guided by topics from json file.
   * @returns guidedByTopics
   */
  getGuidedByTopics(): Observable<TileInfo[]> {
    return this.httpClient.get<TileInfo[]>(this.guidedBytopicsURL);
  }

   getCountryRegionList(): Observable<countryRegionObject> {
    return this.httpClient.get<countryRegionObject>(this.countryRegionURL);
  }

  /**
   * get certified links for the products
   * @returns certified links
   */
   getCertifiedTrainingLinksForAllProduct(): Observable<ResourcesLinks[]> {
    return this.httpClient.get<ResourcesLinks[]>(this.resourcesLinks);
  }

  /**
   * get the product images for selected product
   * @returns product images
   */
  getProductImages():Observable<ProductImage[]> {
    return this.httpClient.get<ProductImage[]>(this.productImagesURL);
  }

  /**
   * get the product html url
   * @returns product html url list
   */
  getProductHtmlUrl():Observable<ProductHtmlUrl[]> {
    return this.httpClient.get<ProductHtmlUrl[]>(this.productHtmlURL);
  }
}
